export function formatPriceCurrency(
    price: number,
    currency: "USD" | "EUR" | "CZK",
) {
    return new Intl.NumberFormat("cs-CZ", {
        style: "currency",
        currency: currency,
        minimumFractionDigits: price % 1 === 0 ? 0 : 2, // Hide decimals if the price is an integer
        maximumFractionDigits: 2,
    }).format(price);
}
